import {observer} from "mobx-react"
import {growlStore, umsPrinterStore, userConfigurationStore} from "../../../store"
import {Page} from "../../ui"
import {UserPrinterConfiguration} from "./UserPrinterConfiguration";


const UserConfigurationPage = observer(function UserConfigurationPage() {

    return <Page cssSuffix={"user-configuration"} breadcrumb={[
        {
            link: '#',
            label: 'Standarddrucker'
        }
    ]}>
        <UserPrinterConfiguration
            options={umsPrinterStore.options}
            data={userConfigurationStore.formData}
            disabled={userConfigurationStore.saving}
            invalid={!userConfigurationStore.valid && userConfigurationStore.dirty}
            onBlur={() => {
                userConfigurationStore.validate()
            }}
            onChange={v => {
                userConfigurationStore.formData = v
            }}
            onSave={async () => {
                const response = await userConfigurationStore.save()

                if (!response) {
                    return
                }
                userConfigurationStore.reset()
                growlStore.add({
                    message: 'Änderungen erfolgreich gespeichert',
                    autoclose: true,
                    closable: true
                })
            }}
            onReset={() => {
                userConfigurationStore.reset()
            }}
            saving={userConfigurationStore.saving}
            saveDisabled={!userConfigurationStore.dirty}
            discardDisabled={!userConfigurationStore.dirty}
        />
    </Page>
})

export {
    UserConfigurationPage
}
